export const products: Record<
    string,
    {
        img: string;
        name: string;
        link: string;
    }[]
> = {
    us: [
        {
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718350524866/%E7%BC%96%E7%BB%84%2010.png',
            name: 'DELTA Pro Ultra',
            link: 'https://www.ecoflow.com/us/delta-pro-ultra',
        },
        {
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718350541137/%E7%BC%96%E7%BB%84%209.png',
            name: 'DELTA Pro 3',
            link: 'https://www.ecoflow.com/us/delta-pro-3-portable-power-station',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724740118947/sl_d3s_uk.png',
            name: 'DELTA 3 Series',
            link: 'https://www.ecoflow.com/us/delta-3-series-portable-power-station',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724740131321/sl_r3m_uk.png',
            name: 'RIVER 3 Series',
            link: 'https://www.ecoflow.com/us/river-3-series-portable-power-station',
        },
        {
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718350554548/%E7%BC%96%E7%BB%84%2049.png',
            name: 'DELTA Pro',
            link: 'https://www.ecoflow.com/us/delta-pro-portable-power-station',
        },
        {
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718350564833/%E7%BC%96%E7%BB%84%2050.png',
            name: 'DELTA 2 Max',
            link: 'https://www.ecoflow.com/us/delta-2-max-portable-power-station',
        },
    ],
    ca: [
        {
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718350524866/%E7%BC%96%E7%BB%84%2010.png',
            name: 'DELTA Pro Ultra',
            link: 'https://www.ecoflow.com/ca/delta-pro-ultra',
        },
        {
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718350541137/%E7%BC%96%E7%BB%84%209.png',
            name: 'DELTA Pro 3',
            link: 'https://www.ecoflow.com/ca/delta-pro-3-portable-power-station',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724740118947/sl_d3s_uk.png',
            name: 'DELTA 3 Series',
            link: 'https://www.ecoflow.com/ca/delta-3-series-portable-power-station',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724740131321/sl_r3m_uk.png',
            name: 'RIVER 3 Series',
            link: 'https://www.ecoflow.com/ca/river-3-series-portable-power-station',
        },
        {
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718350554548/%E7%BC%96%E7%BB%84%2049.png',
            name: 'DELTA Pro',
            link: 'https://www.ecoflow.com/ca/delta-pro-portable-power-station',
        },
        {
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718350564833/%E7%BC%96%E7%BB%84%2050.png',
            name: 'DELTA 2 Max',
            link: 'https://www.ecoflow.com/ca/delta-2-max-portable-power-station',
        },
    ],
    jp: [
        {
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718350524866/%E7%BC%96%E7%BB%84%2010.png',
            name: 'DELTA Pro Ultra',
            link: 'https://www.ecoflow.com/jp/delta-pro-ultra',
        },
        {
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718350541137/%E7%BC%96%E7%BB%84%209.png',
            name: 'DELTA Pro 3',
            link: 'https://www.ecoflow.com/jp/delta-pro-3-portable-power-station',
        },
        {
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718350554548/%E7%BC%96%E7%BB%84%2049.png',
            name: 'DELTA Pro',
            link: 'https://www.ecoflow.com/jp/delta-pro-portable-power-station',
        },
        {
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718350564833/%E7%BC%96%E7%BB%84%2050.png',
            name: 'DELTA 2 Max',
            link: 'https://www.ecoflow.com/jp/delta-2-max-portable-power-station',
        },
    ],
    eu: [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724739909722/sl_DP3.png',
            name: 'DELTA Pro 3',
            link: 'https://www.ecoflow.com/eu/delta-pro-3-portable-power-station',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724739924894/sl_d3s.png',
            name: 'DELTA 3 Series',
            link: 'https://www.ecoflow.com/eu/delta-3-series-portable-power-station',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724739949505/sl_r3m.png',
            name: 'RIVER 3 Series',
            link: 'https://www.ecoflow.com/eu/river-3-series-portable-power-station',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1725174195389/rapid.png',
            name: 'RAPID Magnetic Power Bank',
            link: 'https://www.ecoflow.com/eu/rapid-magnetic-power-bank',
        },
    ],
    de: [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724739909722/sl_DP3.png',
            name: 'DELTA Pro 3',
            link: 'https://www.ecoflow.com/de/delta-pro-3-portable-power-station',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724739924894/sl_d3s.png',
            name: 'DELTA 3 Serie',
            link: 'https://www.ecoflow.com/de/delta-3-series-portable-power-station',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724739949505/sl_r3m.png',
            name: 'RIVER 3 Serie',
            link: 'https://www.ecoflow.com/de/river-3-series-portable-power-station',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1725174195389/rapid.png',
            name: 'RAPID Magnetische Powerbank',
            link: 'https://www.ecoflow.com/de/rapid-magnetic-power-bank',
        },
    ],
    fr: [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724739909722/sl_DP3.png',
            name: 'DELTA Pro 3',
            link: 'https://www.ecoflow.com/fr/delta-pro-3-portable-power-station',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724739924894/sl_d3s.png',
            name: 'Gamme DELTA 3',
            link: 'https://www.ecoflow.com/fr/delta-3-series-portable-power-station',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724739949505/sl_r3m.png',
            name: 'Gamme RIVER 3',
            link: 'https://www.ecoflow.com/fr/river-3-series-portable-power-station',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1725174195389/rapid.png',
            name: 'Batterie externe magnétique RAPID',
            link: 'https://www.ecoflow.com/fr/rapid-magnetic-power-bank',
        },
    ],
    it: [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724739909722/sl_DP3.png',
            name: 'DELTA Pro 3',
            link: 'https://www.ecoflow.com/it/delta-pro-3-portable-power-station',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724739924894/sl_d3s.png',
            name: 'Serie DELTA 3',
            link: 'https://www.ecoflow.com/it/delta-3-series-portable-power-station',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724739949505/sl_r3m.png',
            name: 'Serie RIVER 3',
            link: 'https://www.ecoflow.com/it/river-3-series-portable-power-station',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1725174195389/rapid.png',
            name: 'Power bank magnetica RAPID',
            link: 'https://www.ecoflow.com/it/rapid-magnetic-power-bank',
        },
    ],
    es: [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724739909722/sl_DP3.png',
            name: 'DELTA Pro 3',
            link: 'https://www.ecoflow.com/es/delta-pro-3-portable-power-station',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724739924894/sl_d3s.png',
            name: 'Serie DELTA 3',
            link: 'https://www.ecoflow.com/es/delta-3-series-portable-power-station',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724739949505/sl_r3m.png',
            name: 'Serie RIVER 3',
            link: 'https://www.ecoflow.com/es/river-3-series-portable-power-station',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1725174195389/rapid.png',
            name: 'Banco de energía magnético RAPID',
            link: 'https://www.ecoflow.com/es/rapid-magnetic-power-bank',
        },
    ],
    uk: [
        // {
        //     img: 'https://websiteoss.ecoflow.com/upload/image/1724740103715/sl_DP3_uk.png',
        //     name: 'DELTA Pro 3',
        //     link: 'https://www.ecoflow.com/uk/delta-pro-3-portable-power-station',
        // },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724740118947/sl_d3s_uk.png',
            name: 'DELTA 3 Series',
            link: 'https://www.ecoflow.com/uk/delta-3-series-portable-power-station',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724740131321/sl_r3m_uk.png',
            name: 'RIVER 3 Series',
            link: 'https://www.ecoflow.com/uk/river-3-series-portable-power-station',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1725174195389/rapid.png',
            name: 'RAPID Magnetic Power Bank',
            link: 'https://www.ecoflow.com/uk/rapid-magnetic-power-bank',
        },
    ],
};

// 0625上线

// ---
// 三和一上市后：
// DELTA Pro Ultra: https://www.ecoflow.com/us/delta-pro-ultra
// DELTA Pro 3：
// https://www.ecoflow.com/us/delta-pro-3-portable-power-station
// DELTA 3：
// XXX
// DELTA 2 Max：
// https://www.ecoflow.com/us/delta-2-max-portable-power-station
// RIVER 3 Pro
// XXX
